import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ActivitySocketState {
  isConnected: boolean;
  isConnecting: boolean;
  connectionError: string | null;
  reconnectAttempts: number;
}

const initialState: ActivitySocketState = {
  isConnected: false,
  isConnecting: false,
  connectionError: null,
  reconnectAttempts: 0,
};

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    socketConnecting: (state) => {
      state.isConnecting = true;
      state.connectionError = null;
    },
    socketConnected: (state) => {
      state.isConnected = true;
      state.isConnecting = false;
      state.connectionError = null;
      state.reconnectAttempts = 0;
    },
    socketDisconnected: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
    },
    socketError: (state, action: PayloadAction<string>) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.connectionError = action.payload;
    },
    socketReconnectAttempt: (state) => {
      state.reconnectAttempts += 1;
    },
    resetSocketState: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.connectionError = null;
      state.reconnectAttempts = 0;
    },
  },
});

export const {
  socketConnecting,
  socketConnected,
  socketDisconnected,
  socketError,
  socketReconnectAttempt,
  resetSocketState,
} = activitySlice.actions;

export default activitySlice.reducer;
